import { z } from "zod";

export type GoogleProfile = {
  "iss": "https://accounts.google.com",
  "azp": string,
  "aud": string,
  "sub": string,
  "email": string,
  "email_verified": boolean,
  "nbf": number,
  "name": string,
  "picture": string,
  "given_name": string,
  "family_name": string,
  "iat": number,
  "exp": number,
  "jti": string
}

export const UserZod = z.object({
  email: z.string(),
  accountId: z.string(),
  token: z.string(),
  googleProfile: z.any().optional()
});
export type UserType = z.infer<typeof UserZod>;

// FIXME create user context, covering front and back

export function loadUserLocalStorage(): UserType | undefined {
  const auth = localStorage.userContext;
  if (auth === 'undefined') {
    delete localStorage.userContext;
    return undefined
  }
  return auth ? JSON.parse(auth) : undefined;
};
